import React from 'react'
import PropTypes from 'prop-types'
import styled, { css, createGlobalStyle } from 'styled-components'
import { BiSearch } from 'react-icons/bi'
import { MdClose } from 'react-icons/md'

const CommonInput = ({
  name,
  type = 'text',
  className,
  width,
  order,
  isSearch,
  isClose,
  readOnly,
  placeholder,
  value,
  defaultValue,
  onChange,
  onClick,
  onKeyPress,
  disabled,
  ...props
}) => {
  return (
    <>
      <SearchIconStyle />
      <InputWrapper
        style={{ ...props.style }}
        width={width}
        className={className}>
        {order && <InputOrder>{order}</InputOrder>}
        <Input
          name={name}
          type={type}
          order={order}
          isSearch={isSearch}
          isClose={isClose}
          placeholder={placeholder}
          value={value}
          defaultValue={defaultValue}
          onChange={onChange}
          onKeyPress={onKeyPress}
          readOnly={readOnly}
          disabled={disabled}
          style={disabled ? { color: '#FFA34B' } : null}
        />
        {isSearch && <BiSearch className="search-icon" />}
        {isClose && (
          <MdClose
            className="search-icon"
            onClickCapture={onClick}
            style={{ cursor: 'pointer' }}
            data-id={name}
          />
        )}
      </InputWrapper>
    </>
  )
}

CommonInput.propTypes = {
  name: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  type: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  order: PropTypes.number,
  isSearch: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func,
  onKeyPress: PropTypes.func,
  disabled: PropTypes.bool,
}

const SearchIconStyle = createGlobalStyle`
  .search-icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    padding: 13px 15px;
    cursor: pointer;
    color: #ABAFB4;
  }
`

const InputWrapper = styled.div`
  display: flex;
  position: relative;
  box-sizing: border-box;

  ${({ width }) =>
    width && typeof width === 'number'
      ? css`
          width: ${width}px;
        `
      : css`
          width: width;
        `}
`

const InputOrder = styled.b`
  position: absolute;
  top: 9px;
  left: 15px;
  bottom: 9px;
  font-size: 24px;
  color: #ffa34b;
`

const Input = styled.input`
  flex: 1;
  box-sizing: border-box;
  height: 46px;
  padding: 15px;
  outline: none;
  border: 1px solid #eaebec;
  border-radius: 5px;
  background: #ffffff;
  font-size: 14px;
  color: #333333;

  ::placeholder {
    color: #dadada;
  }

  ${({ order }) =>
    order &&
    css`
      padding-left: 42px;
    `}

  ${({ isSearch }) =>
    isSearch &&
    css`
      padding-right: 30px;
    `}
`

export default CommonInput
